import { CrudOp, tmmAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { EditTMMIcon } from "@org-avp/avp-avengers-ui-shared-icons";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { TMMEditorView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { project }) => {
  const authHelper = authHelperCreator(tmmAuthScope);
  return project != null && authHelper.evaluate(CrudOp.READ, project);
};

export const tmmEditorViewKey = "project_modular_tmm-editor/:tmmId/:brand/:projectId/:modelYear/:mbvKeys";
export const tmmEditorViewModule: ViewModule = {
  viewKey: tmmEditorViewKey,
  viewEl: <TMMEditorView/>,
  displayNameI18nKey: "tmm-editor:viewName",
  menuIconEl: <EditTMMIcon/>,
  isAuthorized,
  translations,
};
